import React from 'react'
import {renderIf} from "../../../views/Shared";
import Translate from "../../../modules/local/Translate";

export const renderMetadataMissing = (metadata = []) => {
  if (!!metadata) return null;
  return renderIf(
    !!metadata.filter(e => e.answer_value === null || e.answer_value === "")?.length > 0,
    <Translate>
      {(t) => (
          <div className="space-x-2 text-xs italic leading-tight">
            <span className="font-bold text-color-100">{`* ${t('missing')} : `}</span>
            <span className="text-color-400">
                {metadata
                    .filter(e => e.answer_value === null || e.answer_value === "")
                    .map((eee) => eee.title)
                    .join(", ")
                }
            </span>
          </div>
      )}
    </Translate>
  )
}
